import { DisplayMode } from '@r-core';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const hideCenterMarkerMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: ({ context, controller }): string => {
			const panelItemGroupId = context?.id ?? null;
			if (!panelItemGroupId) return 'Hide Center Marker';
			const panelItemGroup = controller.kitchen.getReferenceMap(panelItemGroupId)?.panelItemGroup;
			return panelItemGroup?.showCenterDimension ? 'Hide Center Marker' : 'Show Center Marker';
		},
		displayModes: [
			DisplayMode.Overhead,
			DisplayMode.OverheadManufacturing,
			DisplayMode.SkuOverhead,
			DisplayMode.SkuOverheadManufacturing,
			DisplayMode.Panel,
			DisplayMode.Inline,
			DisplayMode.InlineManufacturing,
			DisplayMode.Manufacturing
		],
		isVisible: ({ context, controller }): boolean => {
			if (controller.readonly) return false;
			const panelItemGroupId = context?.id ?? null;
			return !!panelItemGroupId;
		},
		onClick: ({ context, controller }): void => {
			const panelItemGroupId = context?.id ?? null;

			if (panelItemGroupId) {
				const panelItemGroup = controller.kitchen.getReferenceMap(panelItemGroupId)?.panelItemGroup;
				if (panelItemGroup) {
					panelItemGroup.showCenterDimension = !panelItemGroup.showCenterDimension;
				}
			}
		}
	};
};
